import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { AnimatePresence } from 'framer-motion';
import { MassEntityActionMenu, MassOperationDrawer } from '../common/MassOperation/MassOperation';
import usePermissions from '../../pages/Master_Settings/usePermissions';
import { useMemo } from 'react';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarLocked, setSidebarLocked] = useState(false);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      const v = localStorage.getItem('sidebarCollapsed');
      return v === 'true';
    } catch (e) { return false; }
  });

  const [showGlobalAddMenu, setShowGlobalAddMenu] = useState(false);
  const [globalDrawerConfig, setGlobalDrawerConfig] = useState({ isOpen: false, mode: 'followup' });

  const { permissions } = usePermissions('PAG10031');
  const crmOperationPerms = useMemo(() => {
    if (!permissions || !Array.isArray(permissions)) return {};
    return permissions.find(p => p.ModuleCode === 'PAG10031') || {};
  }, [permissions]);

  useEffect(() => {
    try { localStorage.setItem('sidebarCollapsed', sidebarCollapsed); } catch (e) { }
  }, [sidebarCollapsed]);

  const toggleSidebarLock = () => {
    setSidebarLocked(prev => !prev);
    if (sidebarLocked) {
      // If unlocking, close the sidebar
      setSidebarOpen(false);
    } else {
      // If locking, open the sidebar
      setSidebarOpen(true);
    }
  };

  const handleSidebarMouseEnter = () => {
    if (!sidebarLocked) {
      setSidebarHovered(true);
      setSidebarOpen(true);
    }
  };

  const handleSidebarMouseLeave = () => {
    if (!sidebarLocked) {
      setSidebarHovered(false);
      setSidebarOpen(false);
    }
  };

  const effectiveSidebarOpen = sidebarLocked || sidebarHovered || sidebarOpen;

  const handleSetSidebarOpen = (val) => {
    if (!val) {
      setSidebarOpen(false);
      setSidebarLocked(false);
      setSidebarHovered(false);
    } else {
      setSidebarOpen(true);
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        isOpen={effectiveSidebarOpen}
        setIsOpen={handleSetSidebarOpen}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        isLocked={sidebarLocked}
        onMouseEnter={handleSidebarMouseEnter}
        onMouseLeave={handleSidebarMouseLeave}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          toggleSidebarLock={toggleSidebarLock}
          sidebarLocked={sidebarLocked}
          onAddClick={() => setShowGlobalAddMenu(true)}
        />

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      {/* Global Action Menu Drawer */}
      <AnimatePresence>
        {showGlobalAddMenu && (
          <div 
            className="fixed inset-0 z-[6500] bg-black/40 backdrop-blur-sm"
            onClick={() => setShowGlobalAddMenu(false)}
          >
            <MassEntityActionMenu
              variant="drawer"
              crmOperationPerms={crmOperationPerms}
              onAction={(actionId) => {
                setShowGlobalAddMenu(false);
                setGlobalDrawerConfig({ isOpen: true, mode: actionId });
              }}
              onClose={() => setShowGlobalAddMenu(false)}
            />
          </div>
        )}
      </AnimatePresence>

      {/* Global Operation Drawer */}
      <MassOperationDrawer
        isOpen={globalDrawerConfig.isOpen}
        onClose={() => setGlobalDrawerConfig({ ...globalDrawerConfig, isOpen: false })}
        operationMode={globalDrawerConfig.mode}
      />
    </div>
  );
};

export default MainLayout;
